export default function Spinner({ size = 'md' }) {
  if (size === 'lg') {
    return (
      <div className="flex flex-col items-center gap-3">
        <div className="bubble-spinner">
          <span /><span /><span />
        </div>
        <span className="text-xs text-ocean-400 tracking-widest uppercase font-mono animate-depth-pulse">Tauchen…</span>
      </div>
    );
  }
  return (
    <div className="bubble-spinner scale-75">
      <span /><span /><span />
    </div>
  );
}
